import React, { memo, useCallback } from 'react';
import { TouchableOpacity, type TouchableOpacityProps } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationActiveIngredientPressable = memo((props: Props) => {
  const { groupId, onPress, ...pressableProps } = props;

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handlePress = useCallback(() => {
    onPress(groupId);
  }, [groupId, onPress]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <TouchableOpacity
      activeOpacity={0.7}
      onPress={handlePress}
      {...pressableProps}
    />
  );
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = { groupId: string; onPress: (groupId: string) => void } & Omit<
  TouchableOpacityProps,
  'onPress'
>;
